module.exports = __webpack_public_path__ + "media/images/admin/icons/rotate-cw-f81b4cb9876afdd12d2cc7a555bfcdce.svg";